import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

import ModalBulkRefreshCodes from "@/components/modal/UtilityModals/ModalBulkRefreshCodes/ModalBulkRefreshCodes";

const UTILITY_MODAL_COMPONENT_BY_TOOL = {
	refresh_codes: ModalBulkRefreshCodes,
};

const UtilityModals = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const [searchParams] = useSearchParams();

	const tool = searchParams.get("tool");

	if (!tool) {
		return null;
	}

	const UtilityModalComponent = UTILITY_MODAL_COMPONENT_BY_TOOL[tool];
	if (!UtilityModalComponent) {
		return null;
	}

	const handleClose = () => {
		const updatedSearchParams = new URLSearchParams(location.search);
		updatedSearchParams.delete("tool");

		navigate(
			{
				pathname: location.pathname,
				search: updatedSearchParams.toString() ? `?${updatedSearchParams.toString()}` : "",
				hash: location.hash,
			},
			{ replace: true },
		);
	};

	return <UtilityModalComponent onClose={handleClose} />;
};

export default UtilityModals;
